<div class="flex flex-col gap-3">
  <app-expert-availability-header [callDuration]="expert().callDuration" />
  @if (bestMatches(); as bestMatches) {
    <app-expert-availability-best-matches
      [matches]="bestMatches"
      [period]="bestMatchesPeriod()"
      [expertName]="expertName()"
      [hasExpertTimes]="hasExpertTimes()"
      [disabled]="selecting()"
      (selectTime)="onSelectTime($event)"
    />
  }
  <div
    class="legend flex flex-row flex-wrap items-center gap-x-5 gap-y-1"
    data-test-id="expert-availability-legend"
  >
    <strong class="legend-title">All availability</strong>
    @for (item of legendItems; track item.type) {
      <span class="flex flex-row gap-1.5 items-center">
        <span [class]="`legend-swatch ${item.type}`"></span>
        <span class="legend-text">{{ item.label }}</span>
      </span>
    }
  </div>
  <div
    class="calendar flex flex-col min-h-0"
    [attr.aria-busy]="!!pendingTime()"
  >
    <app-schedule-calendar
      [dates]="dates()"
      [timezoneName]="timezoneName()"
      [items]="dayItems()"
    >
      <ng-template
        let-day
        let-nowMinutes="nowMinutes"
        appScheduleCalendarDayContent
      >
        @for (block of periodBlocks().get(day.date) ?? []; track block.start) {
          <app-schedule-calendar-period-bar
            [block]="block"
            [availableLabel]="periodAvailableLabel"
            [preferredLabel]="periodPreferredLabel"
          />
        }
        @for (block of blocks().get(day.date) ?? []; track block.start) {
          <app-schedule-calendar-available-block
            [block]="block"
            [isInPast]="isBlockInPast(day, block, nowMinutes)"
            [editable]="false"
            [selectDuration]="selectDuration()"
            [selectableFrom]="day.isToday ? nowMinutes + 1 : 0"
            [pendingTime]="pendingTime()"
            [busy]="selecting()"
            (selectTime)="onSelectTime($event)"
          />
        }
        @for (
          group of calendarCalls().get(day.date) ?? [];
          track group.items[0].item.callId
        ) {
          <app-interview-period-calendar-call [group]="group" />
        }
      </ng-template>
    </app-schedule-calendar>
    @if (pendingTime()) {
      <div class="loading" data-test-id="expert-availability-loading">
        <mat-progress-bar
          mode="indeterminate"
          aria-label="Checking the selected time"
        />
      </div>
    }
  </div>
</div>
